import { useEffect, useRef, useState } from 'react';

// Eg: targetDate = new Date('Nov 6, 2030 17:00:00').getTime();
const useCountdown = (targetDate: number) => {
  const [timeRemaining, setTimeRemaining] = useState(targetDate - Date.now());
  const intervalRef = useRef<any>();

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(targetDate - Date.now());
    }, 1000);

    intervalRef.current = interval;
    return () => clearInterval(interval);
  }, [targetDate]);

  const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

  const isFinish = days + hours + minutes + seconds <= 0;
  if (isFinish && intervalRef.current) clearInterval(intervalRef.current);

  return { days, hours, minutes, seconds, isFinish };
};

export default useCountdown;
